import React from 'react';
import { render } from '@testing-library/react';
import { Button } from './Button';

describe('Button', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should be a button element with type by default', () => {
		const { getByRole } = render(<Button>Label</Button>);

		const button = getByRole('button');

		expect(button).toHaveAttribute('type', 'button');
		expect(button.tagName).toBe('BUTTON');
	});

	it('should be an anchor element if href attribute exists', () => {
		const { getByRole } = render(
			<Button href="https://v1.anvil.servicetitan.com">Label</Button>
		);

		const button = getByRole('button');

		expect(button).not.toHaveAttribute('type');
		expect(button.tagName).toBe('A');
	});

	it('should be a span element if el prop was set', () => {
		const { getByRole } = render(<Button el="span">Label</Button>);

		const button = getByRole('button');

		expect(button).not.toHaveAttribute('type');
		expect(button.tagName).toBe('SPAN');
	});

	it('should throw error if attributes and props are mismatched', () => {
		expect(() => {
			console.error = jest.fn(); // Prevent actual console.error from showing up in command line
			render(
				<Button el="span" type="button">
					Label
				</Button>
			);
		}).toThrowError();
	});

	it('should throw error if attributes and props are mismatched', () => {
		expect(() => {
			console.error = jest.fn(); // Prevent actual console.error from showing up in command line
			render(
				<Button el="span" href="https://v1.anvil.servicetitan.com">
					Label
				</Button>
			);
		}).toThrowError();
	});

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Button data-auto-sel="automation-selector">Label</Button>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
